function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }
    return "";
}

function setCookie(cname, cValue, days) {
    let d = new Date;
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1e3);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cValue + ";" + expires + ";path=/"
}

function getLocalData(dataName) {
    let value;
    let storage = window.localStorage;
    if (typeof storage !== "undefined") value = storage.getItem("" + dataName);
    if (!value || value.length < 5)
        value = getCookie(dataName);
    if (value === null)
        value = "-";
    return value
}

function setLocalData(dataName, value) {
    let storage = window.localStorage;
    if (typeof storage !== "undefined")
        storage.setItem("" + dataName, value);
    setCookie(dataName, value, 365);
}

function timeSince(strDate) {
    let date = Date.parse(strDate);
    let seconds = Math.floor((new Date() - date) / 1000);

    let interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
        return interval + " سال پیش ";
    }

    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
        return interval + " ماه پیش ";
    }

    interval = Math.floor(seconds / 86400);
    if (interval >= 1) {
        return interval + " روز پیش ";
    }

    interval = Math.floor(seconds / 3600);
    if (interval >= 1) {
        return interval + " ساعت پیش";
    }

    interval = Math.floor(seconds / 60);
    if (interval >= 1) {
        return interval + " دقیقه پیش ";
    }
    return " لحظاتی پیش ";
}

function getCurrentDate(diffMonth) {
    let d = new Date();
    ///d.setDay(d.getDay() + diffDays);
    d.setMonth(d.getMonth() + diffMonth);
    let datestring = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" +
        ("0" + d.getDate()).slice(-2) + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
    window.console.log("in getCurrentDate, datestring is:");
    window.console.log(datestring);
    return datestring;
}

module.exports = {
    getLocalData: getLocalData,
    setLocalData: setLocalData,
    timeSince: timeSince,
    getCurrentDate: getCurrentDate
};